<!-- Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved. -->

<template>
	<navbar-comp id="uploadHeader" appName="Document Upload">
		<template #user-section>
			<overflow-comp placement="bottom-end" arrow gray>
				<template #button>
					<div class="uploadHeader__userNameContainer">
						{{ userName }}
						<icon-comp icon="expand_more_medium"></icon-comp>
					</div>
				</template>
				<template #content>
					<button-comp
						v-for="(item, index) in menu"
						:key="index"
						navGray
						:t-sel="item.tSel"
						@click="onOptionSelected(item.value)"
					>
						{{ item.text }}
					</button-comp>
				</template>
			</overflow-comp>
		</template>
	</navbar-comp>
</template>

<script>
import { NavbarComp, OverflowComp, ButtonComp, IconComp } from '@protolabs/component-library';

export default {
	name: 'header-comp',
	components: {
		NavbarComp,
		OverflowComp,
		ButtonComp,
		IconComp,
	},
	computed: {
		userName() {
			if (window.tokenManager && window.tokenManager.claims) {
				const first = window.tokenManager.claims['given_name'];
				const last = window.tokenManager.claims['family_name'][0];
				return `${first} ${last}`;
			}
			return '';
		},
	},
	data() {
		return {
			menu: [{ text: 'Sign out', value: 'signout' }],
		};
	},
	methods: {
		onOptionSelected(value) {
			switch (value) {
				case 'signout':
					window.location.replace(window.oktaUrl);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.uploadHeader {
	&__userNameContainer {
		@include flex-row-center;
		margin-right: 10px;

		:deep(.icon) {
			margin-left: 5px;
		}
	}
}
</style>
